import { GradeDto } from 'src/store/grades/grade';
import { ArrayUtils } from 'src/utils/array';
import { GradeAction, GradeTypes } from './grades.actions';

export type GradesState = Readonly<{
  grades: GradeDto[];
  errors: any;
}>;

const initialState: GradesState = {
  grades: [],
  errors: null
};

const gradesReducer = (
  state: GradesState = initialState,
  action: GradeAction
) => {
  switch (action.type) {
    case GradeTypes.FetchAll:
      return { ...state, grades: action.grades };
    case GradeTypes.Add:
      return { ...state, grades: [...state.grades, action.grade] };
    case GradeTypes.Update:
      return {
        ...state,
        grades: ArrayUtils.updateListById(state.grades, action.grade)
      };
    case GradeTypes.Delete:
      return {
        ...state,
        grade: null,
        grades: ArrayUtils.deleteFromListById(state.grades, action.grade)
      };
    case GradeTypes.Failure:
      return { ...state, errors: action.errors };
    default:
      return state;
  }
};

export default gradesReducer;
